module.exports = __webpack_public_path__ + "static/media/AUCLogo.f2198b19.png";